import React, { useCallback, useState } from 'react';
import classnames from 'classnames/bind';
import { noop } from 'lodash';
import { ChatIcon } from 'tuui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { SectionHeader } from 'modules/campaigns/components';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ChatHistory } from './ChatHistory';
import { ChatInput } from './ChatInput';
import styles from './chat.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatSection = ({ onSubmit, containerClassName }) => {
    const { onChange: onPromptChange } = useFormFieldValue({ field: 'prompt' });
    const [lastUserMessage, setLastUserMessage] = useState('');

    const handleUserInput = useCallback(
        async message => {
            // Update the last user message to trigger ChatHistory update
            setLastUserMessage(message);
            onPromptChange(message);
            await onSubmit();
        },
        [onPromptChange, onSubmit]
    );

    const handleSuggestionSubmit = useCallback(
        async message => {
            onPromptChange(message);
            await onSubmit();
        },
        [onPromptChange, onSubmit]
    );

    return (
        <CommonCollapsibleCard
            id="chat-section"
            collapsed={false}
            setCollapsed={noop}
            header={
                <SectionHeader
                    headerIcon={<ChatIcon />}
                    headerText={
                        <FormattedMessage id="landing.pages.form.chat.section.title" defaultMessage="Chat with AI" />
                    }
                />
            }
        >
            <div className={classNameBuilder(styles['chat-container'], containerClassName)}>
                <ChatHistory lastUserMessage={lastUserMessage} onSuggestionSubmit={handleSuggestionSubmit} />
                <ChatInput onUserInput={handleUserInput} />
            </div>
        </CommonCollapsibleCard>
    );
};
